import type { Theme } from '@mui/material/styles';

const getMuiListItem = () => ({
  styleOverrides: {
    button: ({ theme }: { theme: Theme }) => ({
      '&:first-of-type': {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
      '&:last-child': {
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
      },
      '&:hover': {
        backgroundColor: theme.palette.semantic.interactive.surface.hover,
      },
    }),
    focusVisible: {},
    root: ({ theme }: { theme: Theme }) => ({
      '&.Mui-focusVisible': {
        backgroundColor: 'transparent',
      },
      '&.Mui-selected': {
        background: 'transparent',
        fontWeight: theme.typography.fontWeightBold,
        '&:hover': {
          background: theme.palette.semantic.interactive.surface.active,
        },
      },
      '&.Mui-disabled': {
        cursor: 'not-allowed',
        pointerEvents: 'inherit',
        '& > *': {
          pointerEvents: 'none',
        },
        '&:active': {
          pointerEvents: 'none',
        },
        '&:hover': {
          backgroundColor: 'inherit',
        },
      },
    }),
  },
});
export default getMuiListItem;
